import { useState, useEffect } from 'react';
import { getApps, initializeApp, getApp } from 'firebase/app';
import { getAuth, onIdTokenChanged } from 'firebase/auth';
import firebaseConfig from '@serie3/freelancesplaceapi/Config/Firebase/firebase';

async function syncTokenToExtension(firebaseUser) {
  if (!firebaseUser) {
    localStorage.removeItem('fp-auth-token');
    localStorage.removeItem('fp-auth-id');
    window.postMessage({ type: 'logoutFreelancersplace' }, '*');
    return;
  }
  const idToken = await firebaseUser.getIdToken();
  localStorage.setItem('fp-auth-token', idToken);
  localStorage.setItem('fp-auth-id', firebaseUser.uid);
  window.postMessage({ type: 'tokenAvailableFreelancersplace', token: idToken, localId: firebaseUser.uid }, '*');
}

export default function useToken() {
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onIdTokenChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
      syncTokenToExtension(firebaseUser);
    });

    const handleRequestToken = (event) => {
      if (event.data?.type !== 'requestTokenFreelancersplace') return;
      const currentUser = auth.currentUser;
      if (currentUser) syncTokenToExtension(currentUser);
    };
    window.addEventListener('message', handleRequestToken);

    return () => {
      unsubscribe();
      window.removeEventListener('message', handleRequestToken);
    };
  }, []);

  return {
    setToken: () => {},
    token: user,
    loading,
  };
}
